module.exports = "<div class=\"container-fluid\">\n\t<div class=\"card card-map\">\n\t\t<div class=\"header\">\n\t\t\t<h4 class=\"title\">Google Maps</h4>\n\t\t</div>\n\t\t<ngui-map zoom=\"13\" center=\"40.748817,-73.985428\">\n\t\t\t<marker [position]=\"[40.748817,-73.985428]\"></marker>\n\t\t\t<map-circle [center]=\"{lat: 40.748817, lng: -73.985428}\"> </map-circle>\n\t\t</ngui-map>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/maps/maps.component.html
// module id = ../../../../../src/app/maps/maps.component.html
// module chunks = main